import React from 'react';
import {OwnerRegisterComponent} from '../../components';

export const OwnerRegister: React.FC = () => {
  return <OwnerRegisterComponent />;
};
